const env = "prod"; //prod | dev
const config = {
    dev: {
        APP_ENV_NAME: "development",
        APP_BASE_API_URL: "http://gateway.5paisa.in/",
        APP_BASE_CHARTSLAYOUT_API_URL: "https://chartslayout.5paisa.com/",
        APP_BASE_CHARTSTT_API_URL: "https://chartstt.5paisa.com/",
        APP_BASE_APIHUB_API_URL: "https://apihub.5paisa.com/",
        APP_BASE_PORTFOLIO_API_URL: "https://portfolioreports.5paisa.com/",
        APP_BASE_20DEPTH_WS_URL: "wss://marketdepth-socket.5paisa.com/",
        APP_BASE_TTWEBSOCKET_WS_URL: "wss://websocket.5paisa.com/TTWebSocket/",
        APP_BASE_CHARTFEED_WS_URL: "wss://ChartFeedsSocket.5paisa.com/",
        APP_BASE_PROD_API_URL: "https://apigateway.5paisa.com/trading/ontgt/",
        APP_BASE_PWAPROD_API_URL: "https://pwaprodapi.5paisa.com/",
        APP_OCP_APIM_KEY: "U2FsdGVkX1/TxMqDYRi2OaFm4dBtHIff2jdF9t06gXiGrTIW6vvJOjumdp1G9ilTUl80YzSjXbhB/KE9h04twQ==",
        APP_HEAD_KEY: "U2FsdGVkX18yBEvZSs0tuycLksmJZxBscKy76X1F5+BocK4/0ulNW3WZVwX4dCckxFoScN/VpEaP0lN0MShw0A==",
        APP_HEAD_REQUEST_CODE: "U2FsdGVkX18vLNX5TQEf1egepU5xKNwqYuEjXUwOZdA=",
        APP_OCP_APIM_KEY_Marketfeed_Token: "U2FsdGVkX1/TzJrHp2LPFIHMH4B4V5hvF37p70hUBnz28cMK3t/V2YIXeHHKDsy4qjQN99NzAkeywBbD8C9jxQ==",
        APP_BASE_SWARAJ_API_URL: "https://swaraj.5paisa.com/Mob/Service1.svc/",
        APP_USER_ID: "U2FsdGVkX184Y72o0llm1bbovimcFpdHGT/mP4g9C2U=",
        APP_PASSWORD: "U2FsdGVkX185Uov6r7dPnPNQh62koGQ4JG3jKLNZBIU=",
    },
    prod: {
        APP_ENV_NAME: "production",
        APP_BASE_API_URL: "https://gateway.5paisa.com/",
        APP_BASE_SWARAJ_API_URL: "https://swaraj.5paisa.com/Mob/Service1.svc/",
        APP_BASE_APIHUB_URL: "https://tradeapihub.5paisa.com/prod-userpass/Mob/Service1.svc/",
        APP_BASE_SWARAJ_CORE_API_URL: "https://swarajcore.5paisa.com/Core/",
        APP_BASE_CHARTSLAYOUT_API_URL: "https://chartslayout.5paisa.com/",
        APP_BASE_CHARTSTT_API_URL: "https://chartstt.5paisa.com/",
        APP_BASE_APIHUB_API_URL: "https://apihub.5paisa.com/",
        APP_BASE_PORTFOLIO_API_URL: "https://portfolioreports.5paisa.com/",
        APP_BASE_20DEPTH_WS_URL: "wss://marketdepth-socket.5paisa.com/",
        APP_BASE_TTWEBSOCKET_WS_URL: "wss://websocket.5paisa.com/TTWebSocket/",
        APP_BASE_CHARTFEED_WS_URL: "wss://ChartFeedsSocket.5paisa.com/",
        APP_BASE_PROD_API_URL: "https://apigateway.5paisa.com/trading/ontgt/",
        APP_BASE_PWAPROD_API_URL: "https://pwaprodapi.5paisa.com/",
        APP_OCP_APIM_KEY: "U2FsdGVkX19OGXrRS8GBGHx7VnbkqREvXcRy+ZvXU+CJ0WUFmWnPFpBOduOTMRRUm0nxzhyCttBDKLosAq0T4A==",
        APP_HEAD_KEY: "U2FsdGVkX1+toPhYNV5qwXcVWM2A6NrqEIlGRCEsvs4/w9cJl8+KwcRWKwFgHYl4GF4uwf/i86WX1mc7x0284Q==",
        APP_HEAD_REQUEST_CODE: "U2FsdGVkX1+RpZEmTzOKIux0vayXBFKCQU3AmoPwlGY=",
        APP_ATLAS_KEY: "U2FsdGVkX19LOFCnmRagdbTL1qY6xSvIJsdMhM9F5ZYqng73l8lZ4ck6tAUpQaHw3A904Mzc10K9J1Yba84OAg==",
        APP_USER_ID: "U2FsdGVkX184Y72o0llm1bbovimcFpdHGT/mP4g9C2U=",
        APP_PASSWORD: "U2FsdGVkX185Uov6r7dPnPNQh62koGQ4JG3jKLNZBIU=",
        APP_OCP_APIM_KEY_Marketfeed_Token: "U2FsdGVkX1/TzJrHp2LPFIHMH4B4V5hvF37p70hUBnz28cMK3t/V2YIXeHHKDsy4qjQN99NzAkeywBbD8C9jxQ==",
        APP_OCP_APIM_SUB_KEY: "U2FsdGVkX19tWAg4YvGW7e25aE1uO1CZ6IkKBBpbWFsqqdbAvjlG/jWut9WBBXlVwciSh4G6s8PlzTlKwyzYGQ=="
    },
};
export const getConfig = () => {
    return config[env];
};
// (() => {
//   var wzrk = document.createElement("script");
//   wzrk.type = "text/javascript";
//   wzrk.async = true;
//   wzrk.src =
//     ("https:" == document.location.protocol
//       ? "https://d2r1yp2w7bby2u.cloudfront.net"
//       : "http://static.clevertap.com") + "/js/clevertap.min.js";
//   var firstScript = document.querySelector("script");
//   if (firstScript && firstScript.parentNode) {
//     firstScript.parentNode.insertBefore(wzrk, firstScript);
//   } else {
//     document.body.appendChild(wzrk);
//   }
// })();
